import { FunctionComponent } from 'react';

import { Header } from './header';
import { Footer } from './footer';
import { Player } from './player';

import './App.scss';

const App: FunctionComponent = () => {
  return (
    <>
      <Header />
      <Player />
      <Footer />
    </>
  );
}

export default App;
